import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=531c9bd9"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=531c9bd9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports